import { DialogTitle, DialogContent } from '@mui/material';
import CodeOfConductForm from './CodeOfConductForm';

export default function ConductStep() {
    return (
        <>
            <DialogTitle>Code of Conduct</DialogTitle>
            <DialogContent sx={{ paddingX: 4 }}>
                <CodeOfConductForm />
            </DialogContent>
        </>
    );
}
